<template>
  <div
    id="pos-root"
    class="pos-root"
    :class="$store.state.UI"
  >
    <orders-list-component
      ref="orders-list-component"
      :selected-order="selectedOrder"
      @updateOrder="updateOrder"
      :modal-opened="modalOpened"
    ></orders-list-component>

    <menu-component :selectedOrder="selectedOrder"></menu-component>

    <selected-order-component
      ref="selected-order-component"
      :temp-order="selectedOrder ? selectedOrder : null"
      @updateOrder="updateOrder"
      section="POS"
      @showConfirm:drinkLimit="openDrinkLimitModal"
    ></selected-order-component>
  </div>

  <teleport to="body">
    <confirm-modal ref="confirm-modal" />
    <countdown-timer-modal ref="countdown-timer-modal-component" />
  </teleport>
</template>

<script>
import SelectedOrderComponent from "@/components/pos/SelectedOrder";
import OrdersListComponent from "@/components/pos/OrdersList";
import MenuComponent from "@/components/pos/Menu";
import { settingsService } from "@/_api/settings.api";
import store from "@/store";
import getPosHelper from "@/_helpers/get-pos-helper";
import { init as initSettings } from "@/_helpers/settings";
import ConfirmModal from "@/components/_modals/ConfirmModal.vue";
import { constants } from "@/constants/constants";
import CountdownTimerModal from "@/components/_modals/CountdownTimerModal.vue";
import { taxesService } from "@/_api/taxes.api";

export default {
  name: "PosRootComponent",
  props: {},
  components: {
    CountdownTimerModal,
    ConfirmModal,
    MenuComponent,
    OrdersListComponent,
    SelectedOrderComponent,
  },
  data() {
    return {
      selectedOrder: null,
      modalOpened: false,
      modalsOpened: [],
    };
  },
  computed: {
    authData() {
      return this.$store.state.auth;
    },
  },
  created() {},
  mounted() {
    this.getSettings();
    getPosHelper(this.authData.posId);

    this.emmiter.on("toggleModals", (data) => {
      if (data.opened) {
        this.modalsOpened.push(data.type);
      } else {
        const index = this.modalsOpened.findIndex((i) => i === data.type);
        if (index !== -1) {
          this.modalsOpened.splice(index, 1);
        }
      }
      this.modalOpened = data.opened;
    });

    this.emmiter.on("showConfirm", (type) => {
      switch (type) {
        case "drinkLimit":
          this.openDrinkLimitModal();
          break;
        case "tabacco-payer":
        case "alcohol-payer":
          this.showPayerAgeRestrictionModal();
          break;
        case "alcohol":
          this.showAlcoholRestrictionModal();
          break;
        case "tabacco":
          this.showTabaccoRestrictionModal();
          break;
      }
    });

    this.emmiter.on("showTimer", (item) => {
      switch (item.type) {
        case "alcoholDrinkLimit":
          this.openAlcoholDrinkLimitModal(item.restrictedUntil);
          break;
      }
    });
  },
  beforeUnmount() {
    this.emmiter.off("toggleModals");
    this.emmiter.off("showConfirm");
    this.emmiter.off("showTimer");
  },
  watch: {},
  methods: {
    async getSettings() {
      try {
        const res = await settingsService.getSettings();
        initSettings(store, res.data);

        const taxRes = await taxesService.getActiveTax();
        const activeTax = taxRes?.payload?.content ?? null;

        store.dispatch("setActiveTax", activeTax);
      } catch (err) {
        console.error(err);
      }
    },

    updateOrder(data) {
      this.selectedOrder = data;
    },

    openDrinkLimitModal() {
      this.$refs["confirm-modal"].show({
        title:
          "This guest has reached the daily drink limit, they can no longer order alcoholic beverages until the end of the day",
        isSmallTitle: true,
        buttonLabel: "OK",
        classes: ["drink-limit"],
      });
    },

    showAlcoholRestrictionModal() {
      this.$refs["confirm-modal"].show({
        title: "Cannot purchase this package plan",
        message:
          "This guest’s cabin member is underage, so you cannot purchase a package plan that contains alcohol.",
        buttonLabel: "Ok",
      });
    },

    showPayerAgeRestrictionModal() {
      this.$refs["confirm-modal"].show({
        title: "Cannot purchase this package plan",
        message:
          "This payer(s) is underage, so you cannot purchase a package plan that contains alcohol or tabacco.",
        buttonLabel: "Ok",
      });
    },

    showTabaccoRestrictionModal() {
      this.$refs["confirm-modal"].show({
        title: "Cannot purchase this package plan",
        message:
          "This guest’s cabin member is underage, so you cannot purchase a package plan that contains tabacco.",
        buttonLabel: "Ok",
      });
    },

    openAlcoholDrinkLimitModal(expiredAt) {
      this.$refs["countdown-timer-modal-component"].show({
        title: constants.alcoholDrinksLimitModal.title,
        message: constants.alcoholDrinksLimitModal.message,
        expired_at: expiredAt,
        buttonLabel: constants.alcoholDrinksLimitModal.ok,
      });
    },
  },
};
</script>

<style lang="less" scoped>
#pos-root {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  padding: 10px 10px 10px 0;
  box-sizing: border-box;
  overflow: hidden;

  :deep {
    #orders-list {
      width: 15%;
      height: 100%;
      min-width: 0;
      min-height: 0;
    }

    #menu {
      width: 58%;
      height: 100%;
      min-width: 0;
      min-height: 0;
    }

    #selected-order {
      width: 27%;
      height: 100%;
      min-width: 0;
      min-height: 0;
      overflow: hidden;
    }

    .drink-limit {
      padding: 50px 23px 17px;
    }
  }
}

@media (max-width: 1850px) {
  #pos-root {
    :deep {
      #orders-list {
        width: 15%;
      }

      #menu {
        width: 54%;
      }

      #selected-order {
        width: 31%;
      }
    }
  }
}

@media (max-width: 1700px) {
  #pos-root {
    :deep {
      #orders-list {
        width: 15%;
      }

      #menu {
        width: 50%;
      }

      #selected-order {
        width: 35%;
      }
    }
  }
}

@media (max-width: 1500px) {
  #pos-root {
    :deep {
      #orders-list {
        width: 15%;
      }

      #menu {
        width: 45%;
      }

      #selected-order {
        width: 40%;
      }
    }
  }
}

@media (max-width: 1350px) {
  #pos-root {
    :deep {
      #orders-list {
        width: 20%;
      }

      #menu {
        width: 30%;
      }

      #selected-order {
        width: 50%;
      }
    }
  }
}
</style>